// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Tutor Chat Enhanced Styles */

/* Chat Container Layout - Modern ChatGPT/Gemini Style */
.ai-chat-container {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Chat Messages Area */
.ai-chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  padding-bottom: 8rem; /* Space for fixed input */
  scroll-behavior: smooth;
}

/* Message Animation */
.ai-message-enter {
  animation: slideInUp 0.3s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fade-in {
  animation: fadeIn 0.5s ease-out forwards;
  opacity: 0;
}

/* Pulse Animation for Interactive Elements */
@keyframes gentlePulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.animate-gentle-pulse {
  animation: gentlePulse 2s ease-in-out infinite;
}

/* Mobile layout adjustments */
@media (max-width: 768px) {
  .ai-chat-messages {
    padding-bottom: 10rem; /* More space on mobile for input + tab navigation */
  }
}

/* Fixed Input Container - ChatGPT Style */
.ai-input-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 40;
  background: transparent;
  padding: 2rem 1rem 1rem;
  border-top: none;
}

/* Mobile input positioning - above tab navigation */
@media (max-width: 768px) {
  .ai-input-container {
    bottom: 4rem; /* Above mobile tab navigation */
    padding: 1rem;
    background: transparent;
  }
  
  .ai-chat-messages {
    padding-bottom: 10rem; /* More space on mobile for input + tab navigation */
  }
  
  /* Adjust for document hub mobile layout */
  .ai-input-container {
    bottom: 5rem; /* Account for mobile tab navigation height */
  }
}

/* Desktop input positioning */
@media (min-width: 769px) {
  .ai-input-container {
    left: var(--sidebar-width, 16rem); /* Account for sidebar */
    bottom: 0;
  }
}

/* Enhanced Input Box - Modern Glassmorphism with Advanced Effects */
.ai-input-box {
  max-width: 48rem;
  margin: 0 auto;
  position: relative;
  background: linear-gradient(145deg, 
    rgba(255, 255, 255, 0.95) 0%, 
    rgba(255, 255, 255, 0.9) 50%, 
    rgba(248, 250, 252, 0.95) 100%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
          backdrop-filter: blur(24px) saturate(180%);
  border: 2px solid rgba(59, 130, 246, 0.1);
  border-radius: 2rem;
  box-shadow: 
    0 20px 40px -12px rgba(0, 0, 0, 0.08),
    0 8px 32px -8px rgba(59, 130, 246, 0.08),
    0 0 0 1px rgba(255, 255, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow: hidden;
}

/* Dark mode input box */
.dark .ai-input-box {
  background: linear-gradient(145deg, 
    rgba(17, 24, 39, 0.95) 0%, 
    rgba(31, 41, 55, 0.9) 50%, 
    rgba(17, 24, 39, 0.95) 100%);
  border-color: rgba(59, 130, 246, 0.2);
  box-shadow: 
    0 20px 40px -12px rgba(0, 0, 0, 0.3),
    0 8px 32px -8px rgba(59, 130, 246, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.02),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.ai-input-box:hover {
  border-color: rgba(59, 130, 246, 0.3);
  transform: translateY(-2px);
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.12),
    0 12px 40px -8px rgba(59, 130, 246, 0.15),
    0 0 0 1px rgba(59, 130, 246, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.ai-input-box:focus-within {
  border-color: rgba(59, 130, 246, 0.5);
  transform: translateY(-3px);
  box-shadow: 
    0 32px 64px -12px rgba(59, 130, 246, 0.2),
    0 16px 48px -8px rgba(59, 130, 246, 0.2),
    0 0 0 1px rgba(59, 130, 246, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

/* Enhanced Input Field */
.ai-input-field {
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  width: 100%;
  padding: 1.5rem 6rem 1.5rem 2rem;
  font-size: 1rem;
  line-height: 1.6;
  color: rgba(17, 24, 39, 0.9);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-weight: 400;
  min-height: 4rem;
  max-height: 10rem;
  transition: all 0.3s ease;
}

.dark .ai-input-field {
  color: rgba(243, 244, 246, 0.95);
}

.ai-input-field::placeholder {
  color: rgba(107, 114, 128, 0.7);
  transition: opacity 0.3s ease;
}

.dark .ai-input-field::placeholder {
  color: rgba(156, 163, 175, 0.7);
}

.ai-input-field:focus::placeholder {
  opacity: 0.5;
}

/* Ultra-Modern Send Button */
.ai-send-button {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: linear-gradient(135deg, 
    #3B82F6 0%, 
    #2563EB 50%, 
    #1D4ED8 100%);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  cursor: pointer;
  box-shadow: 
    0 8px 32px rgba(59, 130, 246, 0.4),
    0 4px 16px rgba(59, 130, 246, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
}

.ai-send-button:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.3) 0%, 
    rgba(255, 255, 255, 0.1) 50%, 
    rgba(255, 255, 255, 0.3) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 50%;
}

.ai-send-button:hover:not(:disabled) {
  background: linear-gradient(135deg, 
    #2563EB 0%, 
    #1D4ED8 50%, 
    #1E40AF 100%);
  transform: scale(1.1) translateY(-1px);
  box-shadow: 
    0 12px 40px rgba(59, 130, 246, 0.5),
    0 6px 20px rgba(59, 130, 246, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.ai-send-button:hover:not(:disabled):before {
  opacity: 1;
}

.ai-send-button:active:not(:disabled) {
  transform: scale(1.05);
}

.ai-send-button:disabled {
  background: linear-gradient(135deg, #9CA3AF, #6B7280);
  cursor: not-allowed;
  transform: scale(0.95);
  box-shadow: 
    0 4px 12px rgba(107, 114, 128, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  opacity: 0.7;
}

/* Modern Utility Classes */
.glassmorphism {
  background: rgba(255, 255, 255, 0.25);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
          backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.dark .glassmorphism {
  background: rgba(31, 41, 55, 0.8);
  border: 1px solid rgba(75, 85, 99, 0.3);
}

/* Enhanced hover effects */
.hover-lift {
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.hover-lift:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

/* Smooth scrolling for chat messages */
.ai-chat-messages {
  scrollbar-width: thin;
  scrollbar-color: rgba(59, 130, 246, 0.3) transparent;
  scroll-behavior: smooth;
}

.ai-chat-messages::-webkit-scrollbar {
  width: 6px;
}

.ai-chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

.ai-chat-messages::-webkit-scrollbar-thumb {
  background: rgba(59, 130, 246, 0.3);
  border-radius: 3px;
}

.ai-chat-messages::-webkit-scrollbar-thumb:hover {
  background: rgba(59, 130, 246, 0.5);
}

/* Modern card styling */
.modern-card {
  background: linear-gradient(145deg, 
    rgba(255, 255, 255, 0.9) 0%, 
    rgba(248, 250, 252, 0.8) 100%);
  -webkit-backdrop-filter: blur(16px);
          backdrop-filter: blur(16px);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 1.5rem;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.06),
    0 1px 0 rgba(255, 255, 255, 0.8),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.dark .modern-card {
  background: linear-gradient(145deg, 
    rgba(31, 41, 55, 0.9) 0%, 
    rgba(17, 24, 39, 0.8) 100%);
  border-color: rgba(75, 85, 99, 0.4);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 1px 0 rgba(255, 255, 255, 0.02),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

/* Interactive Button Styles */
.interactive-button {
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 1rem;
}

.interactive-button:before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.interactive-button:hover:before {
  left: 100%;
}

/* Enhanced Loading Animation */
@keyframes modernPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

.animate-modern-pulse {
  animation: modernPulse 2s ease-in-out infinite;
}

/* Gradient text effect */
.gradient-text {
  background: linear-gradient(135deg, #3B82F6, #8B5CF6, #EC4899);
  background-size: 200% 200%;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  animation: gradientShift 3s ease infinite;
}

@keyframes gradientShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* Message Reaction Styles */
.message-reaction {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border-radius: 50%;
  padding: 0.25rem;
}

.message-reaction:hover {
  transform: scale(1.3);
  background: rgba(59, 130, 246, 0.1);
}

/* Enhanced focus styles for accessibility */
.focus-ring {
  transition: all 0.2s ease;
}

.focus-ring:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
}

/* Responsive improvements */
@media (max-width: 640px) {
  .ai-input-box {
    margin: 0 1rem;
    max-width: calc(100vw - 2rem);
    border-radius: 1.5rem;
  }
  
  .ai-input-field {
    padding: 1.25rem 4.5rem 1.25rem 1.5rem;
    font-size: 0.95rem;
  }
  
  .ai-send-button {
    right: 0.75rem;
    bottom: 0.75rem;
    width: 2.5rem;
    height: 2.5rem;
  }
}

/* Dark mode enhancements */
@media (prefers-color-scheme: dark) {
  .modern-card {
    box-shadow: 
      0 8px 32px rgba(0, 0, 0, 0.4),
      0 1px 0 rgba(255, 255, 255, 0.02),
      inset 0 1px 0 rgba(255, 255, 255, 0.08);
  }
}

/* Accessibility Improvements */
@media (prefers-reduced-motion: reduce) {
  .ai-message-enter,
  .animate-fade-in,
  .animate-gentle-pulse {
    animation: none;
  }
  
  .interactive-button,
  .quick-action-card,
  .ai-input-box {
    transition: none;
  }
}

/* Focus Styles for Accessibility */
.ai-input-field:focus,
.interactive-button:focus,
.quick-action-card:focus {
  outline: 2px solid hsl(var(--color-primary));
  outline-offset: 2px;
}

/* High Contrast Mode Support */
@media (prefers-contrast: high) {
  .ai-input-box {
    border-width: 3px;
    border-color: hsl(var(--color-foreground));
  }
  
  .ai-send-button {
    border: 2px solid hsl(var(--color-background));
  }
  scroll-behavior: smooth;
}

/* Custom scrollbar for chat area - using design system */
.ai-chat-messages::-webkit-scrollbar {
  width: 8px;
}

.ai-chat-messages::-webkit-scrollbar-track {
  background: hsl(var(--color-muted));
  border-radius: 4px;
}

.ai-chat-messages::-webkit-scrollbar-thumb {
  background: hsl(var(--color-muted-foreground) / 0.4);
  border-radius: 4px;
}

.ai-chat-messages::-webkit-scrollbar-thumb:hover {
  background: hsl(var(--color-muted-foreground) / 0.6);
}

/* Enhanced gradient animations using design system */
@keyframes gradient-shift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.ai-message-gradient {
  background: var(--gradient-rainbow);
  background-size: 400% 400%;
  animation: gradient-shift 8s ease infinite;
}

/* Message hover effects */
.ai-message:hover {
  transform: translateY(-1px);
  transition: all 0.2s ease-in-out;
}

.user-message:hover {
  transform: translateY(-1px);
  transition: all 0.2s ease-in-out;
}

/* Typing indicator animation */
.typing-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.typing-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  animation: typing 1.4s infinite ease-in-out;
}

.typing-dot:nth-child(1) { animation-delay: -0.32s; }
.typing-dot:nth-child(2) { animation-delay: -0.16s; }
.typing-dot:nth-child(3) { animation-delay: 0s; }

@keyframes typing {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

/* Enhanced button hover effects */
.ai-action-button {
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
}

.ai-action-button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.ai-action-button:active {
  transform: translateY(0);
}

/* Fullscreen overlay styles */
.ai-chat-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: hsl(var(--color-background) / 0.98);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

/* Enhanced focus styles for accessibility */
.ai-input:focus {
  outline: none;
  ring: 2px;
  ring-color: hsl(var(--color-primary));
  ring-offset: 2px;
  border-color: hsl(var(--color-primary));
}

/* Message animation entrance */
@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ai-message-enter {
  animation: messageSlideIn 0.3s ease-out;
}

/* Markdown code block enhancements */
.ai-chat .prose pre {
  position: relative;
  margin: 1rem 0;
}

.ai-chat .prose pre:hover::after {
  content: "Click to copy";
  position: absolute;
  top: 8px;
  right: 8px;
  background: hsl(var(--color-background) / 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  opacity: 0;
  animation: fadeIn 0.2s ease-in-out forwards;
}

@keyframes fadeIn {
  to { opacity: 1; }
}

/* Quick question grid responsiveness */
.quick-questions-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

@media (max-width: 768px) {
  .quick-questions-grid {
    grid-template-columns: 1fr;
  }
}

/* Status indicator pulse */
.status-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Enhanced glassmorphism effect */
.ai-glass {
  background: hsl(var(--color-surface) / 0.1);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  border: 1px solid hsl(var(--color-border) / 0.2);
  box-shadow: var(--shadow-lg);
}

/* Message styling improvements */
.ai-message:hover {
  transform: translateY(-1px);
  transition: all 0.2s ease-in-out;
}

.user-message:hover {
  transform: translateY(-1px);
  transition: all 0.2s ease-in-out;
}

/* Auto-resize textarea */
.ai-input-field {
  overflow-y: hidden;
  transition: height 0.2s ease;
}

/* Mobile specific adjustments for fullscreen mode */
@media (max-width: 768px) {
  .ai-chat-container.fixed {
    padding-bottom: 4rem; /* Account for mobile tab navigation */
  }
  
  .ai-input-container {
    bottom: 4rem; /* Above mobile tab navigation */
    left: 0;
    right: 0;
  }
}

/* Desktop fullscreen mode */
@media (min-width: 769px) {
  .ai-chat-container.fixed .ai-input-container {
    left: 0;
    right: 0;
  }
}

/* Ensure proper z-index layering */
.ai-input-container {
  z-index: 35; /* Above content, below modals */
}

/* Status message positioning */
.ai-status-message {
  z-index: 30;
}

/* Smooth message entrance animation */
@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ai-message-enter {
  animation: messageSlideIn 0.3s ease-out;
}

/* Hover effects for better interactivity */
.ai-input-box:hover .ai-send-button {
  transform: scale(1.05);
}

.ai-input-field:focus + .ai-send-button {
  background: hsl(var(--color-primary) / 0.9);
  box-shadow: 0 0 0 3px hsl(var(--color-primary) / 0.2);
}

/* Pulse animation for send button when ready */
.ai-send-button:not(:disabled) {
  animation: subtle-pulse 2s infinite;
}

@keyframes subtle-pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 hsl(var(--color-primary) / 0.4);
  }
  50% {
    box-shadow: 0 0 0 4px hsl(var(--color-primary) / 0.1);
  }
}

/* Improved message spacing and typography */
.ai-chat-messages .prose {
  line-height: 1.7;
}

.ai-chat-messages .prose p {
  margin-bottom: 0.75rem;
}

.ai-chat-messages .prose p:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ai-tutor.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,wDAAwD;AACxD;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,oBAAoB,EAAE,0BAA0B;EAChD,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA,6CAA6C;AAC7C;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE;IACE,qBAAqB,EAAE,oDAAoD;EAC7E;AACF;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE;IACE,YAAY,EAAE,gCAAgC;IAC9C,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,qBAAqB,EAAE,oDAAoD;EAC7E;;EAEA,0CAA0C;EAC1C;IACE,YAAY,EAAE,6CAA6C;EAC7D;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,iCAAiC,EAAE,wBAAwB;IAC3D,SAAS;EACX;AACF;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB;;;mCAGiC;EACjC,kDAA0C;UAA1C,0CAA0C;EAC1C,yCAAyC;EACzC,mBAAmB;EACnB;;;;0CAIwC;EACxC,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE;;;gCAG8B;EAC9B,qCAAqC;EACrC;;;;2CAIyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B;;;;0CAIwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B;;;;0CAIwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,8EAA8E;EAC9E,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;iBAGe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAAyD;EACzD,eAAe;EACf;;;0CAGwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;kCAGgC;EAChC,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;;;iBAGe;EACf,sCAAsC;EACtC;;;0CAGwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,sBAAsB;EACtB;;0CAEwC;EACxC,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,kDAA0C;UAA1C,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA,2BAA2B;AAC3B;EACE,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,oDAAoD;EACpD,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,wBAAwB;AACxB;EACE;;kCAEgC;EAChC,mCAA2B;UAA3B,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;EACrB;;;0CAGwC;AAC1C;;AAEA;EACE;;+BAE6B;EAC7B,mCAAmC;EACnC;;;2CAGyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA,yBAAyB;AACzB;EACE,8DAA8D;EAC9D,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,4BAA4B;AAC5B;EACE,iDAAiD;EACjD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE;IACE,cAAc;IACd,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,aAAa;IACb,cAAc;EAChB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE;;;6CAGyC;EAC3C;AACF;;AAEA,+BAA+B;AAC/B;EACE;;;IAGE,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;EAClB;AACF;;AAEA,mCAAmC;AACnC;;;EAGE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE;IACE,iBAAiB;IACjB,0CAA0C;EAC5C;;EAEA;IACE,8CAA8C;EAChD;EACA,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;AACtD;;AAEA,qDAAqD;AACrD;EACE,KAAK,2BAA2B,EAAE;EAClC,MAAM,6BAA6B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,2BAA2B,uBAAuB,EAAE;AACpD,2BAA2B,uBAAuB,EAAE;AACpD,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA,kCAAkC;AAClC;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,KAAK,UAAU,EAAE;AACnB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,2BAA2B;AAC3B;EACE,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,kCAAkC;AAClC;EACE,2CAA2C;EAC3C,mCAA2B;UAA3B,2BAA2B;EAC3B,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,oDAAoD;AACpD;EACE;IACE,oBAAoB,EAAE,sCAAsC;EAC9D;;EAEA;IACE,YAAY,EAAE,gCAAgC;IAC9C,OAAO;IACP,QAAQ;EACV;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,OAAO;IACP,QAAQ;EACV;AACF;;AAEA,mCAAmC;AACnC;EACE,WAAW,EAAE,gCAAgC;AAC/C;;AAEA,+BAA+B;AAC/B;EACE,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA,2CAA2C;AAC3C;EACE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA,+CAA+C;AAC/C;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,mDAAmD;EACrD;EACA;IACE,qDAAqD;EACvD;AACF;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* AI Tutor Chat Enhanced Styles */\n\n/* Chat Container Layout - Modern ChatGPT/Gemini Style */\n.ai-chat-container {\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Chat Messages Area */\n.ai-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n  padding-bottom: 8rem; /* Space for fixed input */\n  scroll-behavior: smooth;\n}\n\n/* Message Animation */\n.ai-message-enter {\n  animation: slideInUp 0.3s ease-out;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.5s ease-out forwards;\n  opacity: 0;\n}\n\n/* Pulse Animation for Interactive Elements */\n@keyframes gentlePulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.8;\n  }\n}\n\n.animate-gentle-pulse {\n  animation: gentlePulse 2s ease-in-out infinite;\n}\n\n/* Mobile layout adjustments */\n@media (max-width: 768px) {\n  .ai-chat-messages {\n    padding-bottom: 10rem; /* More space on mobile for input + tab navigation */\n  }\n}\n\n/* Fixed Input Container - ChatGPT Style */\n.ai-input-container {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 40;\n  background: transparent;\n  padding: 2rem 1rem 1rem;\n  border-top: none;\n}\n\n/* Mobile input positioning - above tab navigation */\n@media (max-width: 768px) {\n  .ai-input-container {\n    bottom: 4rem; /* Above mobile tab navigation */\n    padding: 1rem;\n    background: transparent;\n  }\n  \n  .ai-chat-messages {\n    padding-bottom: 10rem; /* More space on mobile for input + tab navigation */\n  }\n  \n  /* Adjust for document hub mobile layout */\n  .ai-input-container {\n    bottom: 5rem; /* Account for mobile tab navigation height */\n  }\n}\n\n/* Desktop input positioning */\n@media (min-width: 769px) {\n  .ai-input-container {\n    left: var(--sidebar-width, 16rem); /* Account for sidebar */\n    bottom: 0;\n  }\n}\n\n/* Enhanced Input Box - Modern Glassmorphism with Advanced Effects */\n.ai-input-box {\n  max-width: 48rem;\n  margin: 0 auto;\n  position: relative;\n  background: linear-gradient(145deg, \n    rgba(255, 255, 255, 0.95) 0%, \n    rgba(255, 255, 255, 0.9) 50%, \n    rgba(248, 250, 252, 0.95) 100%);\n  backdrop-filter: blur(24px) saturate(180%);\n  border: 2px solid rgba(59, 130, 246, 0.1);\n  border-radius: 2rem;\n  box-shadow: \n    0 20px 40px -12px rgba(0, 0, 0, 0.08),\n    0 8px 32px -8px rgba(59, 130, 246, 0.08),\n    0 0 0 1px rgba(255, 255, 255, 0.05),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  overflow: hidden;\n}\n\n/* Dark mode input box */\n.dark .ai-input-box {\n  background: linear-gradient(145deg, \n    rgba(17, 24, 39, 0.95) 0%, \n    rgba(31, 41, 55, 0.9) 50%, \n    rgba(17, 24, 39, 0.95) 100%);\n  border-color: rgba(59, 130, 246, 0.2);\n  box-shadow: \n    0 20px 40px -12px rgba(0, 0, 0, 0.3),\n    0 8px 32px -8px rgba(59, 130, 246, 0.15),\n    0 0 0 1px rgba(255, 255, 255, 0.02),\n    inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.ai-input-box:hover {\n  border-color: rgba(59, 130, 246, 0.3);\n  transform: translateY(-2px);\n  box-shadow: \n    0 25px 50px -12px rgba(0, 0, 0, 0.12),\n    0 12px 40px -8px rgba(59, 130, 246, 0.15),\n    0 0 0 1px rgba(59, 130, 246, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n.ai-input-box:focus-within {\n  border-color: rgba(59, 130, 246, 0.5);\n  transform: translateY(-3px);\n  box-shadow: \n    0 32px 64px -12px rgba(59, 130, 246, 0.2),\n    0 16px 48px -8px rgba(59, 130, 246, 0.2),\n    0 0 0 1px rgba(59, 130, 246, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.4);\n}\n\n/* Enhanced Input Field */\n.ai-input-field {\n  background: transparent;\n  border: none;\n  outline: none;\n  resize: none;\n  width: 100%;\n  padding: 1.5rem 6rem 1.5rem 2rem;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: rgba(17, 24, 39, 0.9);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-weight: 400;\n  min-height: 4rem;\n  max-height: 10rem;\n  transition: all 0.3s ease;\n}\n\n.dark .ai-input-field {\n  color: rgba(243, 244, 246, 0.95);\n}\n\n.ai-input-field::placeholder {\n  color: rgba(107, 114, 128, 0.7);\n  transition: opacity 0.3s ease;\n}\n\n.dark .ai-input-field::placeholder {\n  color: rgba(156, 163, 175, 0.7);\n}\n\n.ai-input-field:focus::placeholder {\n  opacity: 0.5;\n}\n\n/* Ultra-Modern Send Button */\n.ai-send-button {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  background: linear-gradient(135deg, \n    #3B82F6 0%, \n    #2563EB 50%, \n    #1D4ED8 100%);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  cursor: pointer;\n  box-shadow: \n    0 8px 32px rgba(59, 130, 246, 0.4),\n    0 4px 16px rgba(59, 130, 246, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  position: relative;\n  overflow: hidden;\n}\n\n.ai-send-button:before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, \n    rgba(255, 255, 255, 0.3) 0%, \n    rgba(255, 255, 255, 0.1) 50%, \n    rgba(255, 255, 255, 0.3) 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  border-radius: 50%;\n}\n\n.ai-send-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, \n    #2563EB 0%, \n    #1D4ED8 50%, \n    #1E40AF 100%);\n  transform: scale(1.1) translateY(-1px);\n  box-shadow: \n    0 12px 40px rgba(59, 130, 246, 0.5),\n    0 6px 20px rgba(59, 130, 246, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n.ai-send-button:hover:not(:disabled):before {\n  opacity: 1;\n}\n\n.ai-send-button:active:not(:disabled) {\n  transform: scale(1.05);\n}\n\n.ai-send-button:disabled {\n  background: linear-gradient(135deg, #9CA3AF, #6B7280);\n  cursor: not-allowed;\n  transform: scale(0.95);\n  box-shadow: \n    0 4px 12px rgba(107, 114, 128, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  opacity: 0.7;\n}\n\n/* Modern Utility Classes */\n.glassmorphism {\n  background: rgba(255, 255, 255, 0.25);\n  backdrop-filter: blur(20px) saturate(180%);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n}\n\n.dark .glassmorphism {\n  background: rgba(31, 41, 55, 0.8);\n  border: 1px solid rgba(75, 85, 99, 0.3);\n}\n\n/* Enhanced hover effects */\n.hover-lift {\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.hover-lift:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n/* Smooth scrolling for chat messages */\n.ai-chat-messages {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(59, 130, 246, 0.3) transparent;\n  scroll-behavior: smooth;\n}\n\n.ai-chat-messages::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ai-chat-messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.ai-chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(59, 130, 246, 0.3);\n  border-radius: 3px;\n}\n\n.ai-chat-messages::-webkit-scrollbar-thumb:hover {\n  background: rgba(59, 130, 246, 0.5);\n}\n\n/* Modern card styling */\n.modern-card {\n  background: linear-gradient(145deg, \n    rgba(255, 255, 255, 0.9) 0%, \n    rgba(248, 250, 252, 0.8) 100%);\n  backdrop-filter: blur(16px);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 1.5rem;\n  box-shadow: \n    0 8px 32px rgba(0, 0, 0, 0.06),\n    0 1px 0 rgba(255, 255, 255, 0.8),\n    inset 0 1px 0 rgba(255, 255, 255, 0.4);\n}\n\n.dark .modern-card {\n  background: linear-gradient(145deg, \n    rgba(31, 41, 55, 0.9) 0%, \n    rgba(17, 24, 39, 0.8) 100%);\n  border-color: rgba(75, 85, 99, 0.4);\n  box-shadow: \n    0 8px 32px rgba(0, 0, 0, 0.3),\n    0 1px 0 rgba(255, 255, 255, 0.02),\n    inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n/* Interactive Button Styles */\n.interactive-button {\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 1rem;\n}\n\n.interactive-button:before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.interactive-button:hover:before {\n  left: 100%;\n}\n\n/* Enhanced Loading Animation */\n@keyframes modernPulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.05);\n  }\n}\n\n.animate-modern-pulse {\n  animation: modernPulse 2s ease-in-out infinite;\n}\n\n/* Gradient text effect */\n.gradient-text {\n  background: linear-gradient(135deg, #3B82F6, #8B5CF6, #EC4899);\n  background-size: 200% 200%;\n  background-clip: text;\n  -webkit-background-clip: text;\n  color: transparent;\n  animation: gradientShift 3s ease infinite;\n}\n\n@keyframes gradientShift {\n  0%, 100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n/* Message Reaction Styles */\n.message-reaction {\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  border-radius: 50%;\n  padding: 0.25rem;\n}\n\n.message-reaction:hover {\n  transform: scale(1.3);\n  background: rgba(59, 130, 246, 0.1);\n}\n\n/* Enhanced focus styles for accessibility */\n.focus-ring {\n  transition: all 0.2s ease;\n}\n\n.focus-ring:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);\n}\n\n/* Responsive improvements */\n@media (max-width: 640px) {\n  .ai-input-box {\n    margin: 0 1rem;\n    max-width: calc(100vw - 2rem);\n    border-radius: 1.5rem;\n  }\n  \n  .ai-input-field {\n    padding: 1.25rem 4.5rem 1.25rem 1.5rem;\n    font-size: 0.95rem;\n  }\n  \n  .ai-send-button {\n    right: 0.75rem;\n    bottom: 0.75rem;\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n}\n\n/* Dark mode enhancements */\n@media (prefers-color-scheme: dark) {\n  .modern-card {\n    box-shadow: \n      0 8px 32px rgba(0, 0, 0, 0.4),\n      0 1px 0 rgba(255, 255, 255, 0.02),\n      inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  }\n}\n\n/* Accessibility Improvements */\n@media (prefers-reduced-motion: reduce) {\n  .ai-message-enter,\n  .animate-fade-in,\n  .animate-gentle-pulse {\n    animation: none;\n  }\n  \n  .interactive-button,\n  .quick-action-card,\n  .ai-input-box {\n    transition: none;\n  }\n}\n\n/* Focus Styles for Accessibility */\n.ai-input-field:focus,\n.interactive-button:focus,\n.quick-action-card:focus {\n  outline: 2px solid hsl(var(--color-primary));\n  outline-offset: 2px;\n}\n\n/* High Contrast Mode Support */\n@media (prefers-contrast: high) {\n  .ai-input-box {\n    border-width: 3px;\n    border-color: hsl(var(--color-foreground));\n  }\n  \n  .ai-send-button {\n    border: 2px solid hsl(var(--color-background));\n  }\n  scroll-behavior: smooth;\n}\n\n/* Custom scrollbar for chat area - using design system */\n.ai-chat-messages::-webkit-scrollbar {\n  width: 8px;\n}\n\n.ai-chat-messages::-webkit-scrollbar-track {\n  background: hsl(var(--color-muted));\n  border-radius: 4px;\n}\n\n.ai-chat-messages::-webkit-scrollbar-thumb {\n  background: hsl(var(--color-muted-foreground) / 0.4);\n  border-radius: 4px;\n}\n\n.ai-chat-messages::-webkit-scrollbar-thumb:hover {\n  background: hsl(var(--color-muted-foreground) / 0.6);\n}\n\n/* Enhanced gradient animations using design system */\n@keyframes gradient-shift {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n.ai-message-gradient {\n  background: var(--gradient-rainbow);\n  background-size: 400% 400%;\n  animation: gradient-shift 8s ease infinite;\n}\n\n/* Message hover effects */\n.ai-message:hover {\n  transform: translateY(-1px);\n  transition: all 0.2s ease-in-out;\n}\n\n.user-message:hover {\n  transform: translateY(-1px);\n  transition: all 0.2s ease-in-out;\n}\n\n/* Typing indicator animation */\n.typing-dots {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.typing-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  animation: typing 1.4s infinite ease-in-out;\n}\n\n.typing-dot:nth-child(1) { animation-delay: -0.32s; }\n.typing-dot:nth-child(2) { animation-delay: -0.16s; }\n.typing-dot:nth-child(3) { animation-delay: 0s; }\n\n@keyframes typing {\n  0%, 80%, 100% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1.2);\n    opacity: 1;\n  }\n}\n\n/* Enhanced button hover effects */\n.ai-action-button {\n  transition: all 0.2s ease-in-out;\n  position: relative;\n  overflow: hidden;\n}\n\n.ai-action-button:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.ai-action-button:active {\n  transform: translateY(0);\n}\n\n/* Fullscreen overlay styles */\n.ai-chat-fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  background: hsl(var(--color-background) / 0.98);\n  backdrop-filter: blur(10px);\n}\n\n/* Enhanced focus styles for accessibility */\n.ai-input:focus {\n  outline: none;\n  ring: 2px;\n  ring-color: hsl(var(--color-primary));\n  ring-offset: 2px;\n  border-color: hsl(var(--color-primary));\n}\n\n/* Message animation entrance */\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ai-message-enter {\n  animation: messageSlideIn 0.3s ease-out;\n}\n\n/* Markdown code block enhancements */\n.ai-chat .prose pre {\n  position: relative;\n  margin: 1rem 0;\n}\n\n.ai-chat .prose pre:hover::after {\n  content: \"Click to copy\";\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: hsl(var(--color-background) / 0.7);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  opacity: 0;\n  animation: fadeIn 0.2s ease-in-out forwards;\n}\n\n@keyframes fadeIn {\n  to { opacity: 1; }\n}\n\n/* Quick question grid responsiveness */\n.quick-questions-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n}\n\n@media (max-width: 768px) {\n  .quick-questions-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Status indicator pulse */\n.status-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Enhanced glassmorphism effect */\n.ai-glass {\n  background: hsl(var(--color-surface) / 0.1);\n  backdrop-filter: blur(20px);\n  border: 1px solid hsl(var(--color-border) / 0.2);\n  box-shadow: var(--shadow-lg);\n}\n\n/* Message styling improvements */\n.ai-message:hover {\n  transform: translateY(-1px);\n  transition: all 0.2s ease-in-out;\n}\n\n.user-message:hover {\n  transform: translateY(-1px);\n  transition: all 0.2s ease-in-out;\n}\n\n/* Auto-resize textarea */\n.ai-input-field {\n  overflow-y: hidden;\n  transition: height 0.2s ease;\n}\n\n/* Mobile specific adjustments for fullscreen mode */\n@media (max-width: 768px) {\n  .ai-chat-container.fixed {\n    padding-bottom: 4rem; /* Account for mobile tab navigation */\n  }\n  \n  .ai-input-container {\n    bottom: 4rem; /* Above mobile tab navigation */\n    left: 0;\n    right: 0;\n  }\n}\n\n/* Desktop fullscreen mode */\n@media (min-width: 769px) {\n  .ai-chat-container.fixed .ai-input-container {\n    left: 0;\n    right: 0;\n  }\n}\n\n/* Ensure proper z-index layering */\n.ai-input-container {\n  z-index: 35; /* Above content, below modals */\n}\n\n/* Status message positioning */\n.ai-status-message {\n  z-index: 30;\n}\n\n/* Smooth message entrance animation */\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ai-message-enter {\n  animation: messageSlideIn 0.3s ease-out;\n}\n\n/* Hover effects for better interactivity */\n.ai-input-box:hover .ai-send-button {\n  transform: scale(1.05);\n}\n\n.ai-input-field:focus + .ai-send-button {\n  background: hsl(var(--color-primary) / 0.9);\n  box-shadow: 0 0 0 3px hsl(var(--color-primary) / 0.2);\n}\n\n/* Pulse animation for send button when ready */\n.ai-send-button:not(:disabled) {\n  animation: subtle-pulse 2s infinite;\n}\n\n@keyframes subtle-pulse {\n  0%, 100% {\n    box-shadow: 0 0 0 0 hsl(var(--color-primary) / 0.4);\n  }\n  50% {\n    box-shadow: 0 0 0 4px hsl(var(--color-primary) / 0.1);\n  }\n}\n\n/* Improved message spacing and typography */\n.ai-chat-messages .prose {\n  line-height: 1.7;\n}\n\n.ai-chat-messages .prose p {\n  margin-bottom: 0.75rem;\n}\n\n.ai-chat-messages .prose p:last-child {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
